import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onEnd(evt) {
    // Debug log to check the dragged item and its data attributes
    console.log('Sortable onEnd evt.item:', evt.item)
    console.log('Sortable onEnd evt.item.dataset:', evt.item.dataset)
    const recordId = evt.item.dataset.sortableId
    if (!recordId) {
      this.showToast("Error: ID not found for dragged row.", "error")
      console.error("Sortable: Missing data-sortable-id on dragged row", evt.item)
      evt.item.style.opacity = '1'
      this.sortable.sort(this.originalOrder)
      return
    }
    // Prefer DOM neighbors after the drop — immune to newIndex off-by-one.
    // Keep absolute position for non-screen lists (info items, TV channels, etc.).
    const beforeId = evt.item.nextElementSibling?.dataset?.sortableId || null
    const afterId = evt.item.previousElementSibling?.dataset?.sortableId || null
    const newPosition = evt.newIndex + 1 // 1-based fallback

    // Show loading state
    evt.item.style.opacity = '0.6'

    // Get the API endpoint from data-sortable-url-value
    let url = this.urlValue
    if (!url) {
      this.showToast("Error: No API endpoint provided for sorting.", "error")
      evt.item.style.opacity = '1'
      return
    }
    url = url.replace(":id", recordId)

    // Send AJAX request to update position
    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        position: newPosition,
        before_id: beforeId,
        after_id: afterId
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      evt.item.style.opacity = '1'

      if (data.success) {
        this.showToast("Position updated successfully", "success")
        // Update position numbers in the DOM
        const rows = Array.from(evt.item.parentNode.children);
        rows.forEach((row, idx) => {
          const posCell = row.querySelector('.position-cell');
          if (posCell) {
            const badge = posCell.querySelector('span');
            if (badge) badge.textContent = idx + 1;
          }
        });
        // No page reload!
      } else {
        this.showToast("Failed to update position", "error")
        this.sortable.sort(this.originalOrder)
      }
    })
    .catch(error => {
      console.error("Error updating position:", error)
      evt.item.style.opacity = '1'
      this.showToast("Failed to update position", "error")
      this.sortable.sort(this.originalOrder)
    })
  }

  startDrag(evt) {
    this.originalOrder = this.sortable.toArray()
  }

  showToast(message, type) {
    const event = new CustomEvent("show-toast", {
      detail: { message, type }
    })
    document.dispatchEvent(event)
  }
}
